import { createSlice } from "@reduxjs/toolkit";

const initialState = {
 fromDate: null,
 toDate: null,
 rows: [],
 grid: {
 filterModel: null,
 columnState: null,
 quickFilterText: "",
 selectedIds: [],
 scrollTop: 0,
 },
 hydrated: false,
};

const slice = createSlice({
 name: "purchaseOrders",
 initialState,
 reducers: {
 setFilters(state, { payload }) {
 const { fromDate, toDate } = payload || {};
 if (fromDate !== undefined) state.fromDate = fromDate;
 if (toDate !== undefined) state.toDate = toDate;
 },
 setRows(state, { payload }) {
 state.rows = payload || [];
 },
 saveGridState(state, { payload }) {
 state.grid = { ...state.grid, ...payload };
 },
 setHydrated(state, { payload }) {
 state.hydrated = !!payload;
 },
 resetAll() {
 return initialState;
 },
 },
});

export const { setFilters, setRows, saveGridState, setHydrated, resetAll } =
 slice.actions;

export default slice.reducer;
